import { useQuery, useMutation, useQueryClient } from "react-query"
import {
  getPayout,
  addPayoutDistribution,
  updatePayoutDistribution,
  removePayoutDistribution,
  sendAllPayouts,
  PayoutDistributionParams,
} from "@requests/payouts"

export function usePayout(payoutId: number | string, options?: { enabled?: boolean }) {
  return useQuery(["payout", payoutId], () => getPayout(payoutId), {
    enabled: options?.enabled ?? true,
  })
}

export function useAddPayoutDistribution(payoutId: number | string) {
  const queryClient = useQueryClient()

  return useMutation(
    (params: PayoutDistributionParams & { amount: number }) =>
      addPayoutDistribution(payoutId, params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["payout", payoutId])
      },
    },
  )
}

export function useUpdatePayoutDistribution(payoutId: number | string) {
  const queryClient = useQueryClient()

  return useMutation(
    (params: PayoutDistributionParams & { id: number }) => {
      const { id, ...payload } = params
      return updatePayoutDistribution(payoutId, id, payload)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["payout", payoutId])
      },
    },
  )
}

export function useRemovePayoutDistribution(payoutId: number | string) {
  const queryClient = useQueryClient()

  return useMutation(
    (distributionId: number) => removePayoutDistribution(payoutId, distributionId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["payout", payoutId])
      },
    },
  )
}

export function useSendAllPayouts(payoutId: number | string) {
  const queryClient = useQueryClient()

  return useMutation(() => sendAllPayouts(payoutId), {
    onSuccess: () => {
      queryClient.invalidateQueries(["payout", payoutId])
      queryClient.invalidateQueries(["payouts"])
    },
  })
}
